import React from 'react';
import { connect } from 'react-redux';
import { hasRole } from './roles';
import NoAccess from '../../views/misc/NoAccess';

function RequireRole({ ready, allowed, children }) {
  if (!ready) return null;
  return allowed ? children : <NoAccess />;
}

function mapStateToProps(state, ownProps) {
  const { isAuthenticated, isAdmin, company, demoEnabled, demoMode, no_companies } = state.common;
  const ready = Boolean(demoEnabled || demoMode || (isAuthenticated && (company || isAdmin || no_companies)));
  return { ready, allowed: hasRole(state, ownProps.minRole) };
}

export default connect(mapStateToProps)(RequireRole);
